import { CHANGE_INTRO_SLIDES } from "../actions/introSlides";

export default function introSlides(state = [], action) {
  switch (action.type) {
    case CHANGE_INTRO_SLIDES:
      return action.introSlides.map((introSlide, index) => ({
        key: index.toString(),

        ...introSlide
      }));

    default:
      return state;
  }
}
